import React from "react";
import LoadingIcon from "components/LoadingIcon";
import clsx from "clsx";

const LoadingView = (props: {
  message: string;
  className?: string;
  containerClassName?: string;
  messageClassName?: string;
  button?: React.ReactNode;
}) => {
  return (
    <div
      className={clsx(
        "h-[calc(100vh-240px)] flex flex-col items-center justify-center",
        props.containerClassName
      )}
    >
      <LoadingIcon className={props.className} />
      <span
        className={clsx("text-gray-500 text-xs mt-4", props.messageClassName)}
      >
        {props.message}
      </span>
      {props.button}
    </div>
  );
};

export default LoadingView;
